// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"e9d15007","97":"b1004997","243":"11f46709","317":"02ea8797","357":"ffc10589","429":"bbcab9e2","434":"b6139fa2","453":"58130077","581":"e6214b35","611":"d3c379f7","632":"0ab077a1","779":"a07c8380","855":"8ab48342","913":"56b90f58"}[chunkId] + ".chunk.js";
};